// Detects whether a urql error is a Grab channel error (marketplace-order
// mutations embed a `[GRAB_<CODE>]` token / `extensions.code`). The global
// error exchange skips its raw toast for these — the marketplace-order
// containers already show a short, user-facing label for them — so the user
// only sees one toast per failure instead of two.

import type { CombinedError } from "urql";

const GRAB_CODE_TOKEN_PATTERN = /\[(GRAB_[A-Z_]+)\]/;

export const isGrabChannelError = (
	error: CombinedError | undefined | null,
): boolean => {
	if (!error) return false;

	for (const graphQLError of error.graphQLErrors ?? []) {
		const code = graphQLError.extensions?.code;
		if (typeof code === "string" && code.startsWith("GRAB_")) {
			return true;
		}
	}

	return GRAB_CODE_TOKEN_PATTERN.test(error.message ?? "");
};
